import { css } from 'styled-components';

export const DashboardTextContentStyle = css`
  font-family:
    'Instrument Sans',
    'Pretendard',
    -apple-system,
    BlinkMacSystemFont,
    Roboto,
    helvetica,
    Apple SD Gothic Neo,
    sans-serif;

  word-break: break-all;
  h1 {
    font-size: 36px;
  }
  h2 {
    font-size: 28px;
  }
  h3 {
    font-size: 24px;
  }
  h4 {
    font-size: 20px;
  }
  h1,
  h2,
  h3,
  h4 {
    line-height: 1.2;
    margin: 0;
    font-weight: 600;
    strong {
      font-weight: 700;
    }
  }
  p {
    font-size: 16px;
    line-height: 1.6;
    margin: 0px;
    margin-bottom: 0.4em;
  }
  ul,
  ol {
    font-size: 16px;
    line-height: 1.6;
    margin: 0px;
    margin-bottom: 0.4em;
  }
`;
